import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Icon from '@mui/material/Icon';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CardMedia from '@mui/material/CardMedia';
import { useTheme } from '@mui/material/styles';
import useDynamicFingoLogo from '../../hooks/useDynamicFingoLogo';

const FingoCircularProgressLoader = () => {
  const theme = useTheme();
  const fingoLogo = useDynamicFingoLogo();
  return (
    <Stack alignItems="center">
      <svg>
        <linearGradient id="linearColors" x1="0" y1="0" x2="1" y2="1">
          <stop offset="20%" stopColor={theme.palette.loader.gradientStart} />
          <stop offset="90%" stopColor={theme.palette.loader.gradientEnd} />
        </linearGradient>
      </svg>
      <CircularProgress
        size={60}
        sx={{ circle: { stroke: 'url(#linearColors)' } }}
      />
      <Typography pt={2} variant="body2" fontWeight="500">LA LIQUIDEZ QUE NECESITAS HOY</Typography>
      <Icon sx={{ width: 150, height: 'auto' }}>
        <CardMedia
          component="img"
          image={fingoLogo}
          alt="fingo-logo"
          style={{ height: '100%', width: '100%' }}
        />
      </Icon>
    </Stack>
  );
};

export default FingoCircularProgressLoader;
